import React, { useEffect } from "react";
import { HomePageWrapper } from "./homePage.styled";
import SideNavBar from "../../components/navBar/sideNavBar";
import { Outlet, useNavigate } from "react-router-dom";
import TopNavBarOne from "../../components/header/topNavBarOne";
import { Container } from "react-bootstrap";
import { ROUTE_NAMES } from "../../constants/routeNames";

export const HomePage = () => {
  const navigation = useNavigate();
  const roleID = localStorage.getItem("@role");
  const roleid = 102 == Number(roleID);
  useEffect(() => {
    if (roleid) {
      navigation(ROUTE_NAMES.CEP_Dashboard);
    } else {
      // navigation(ROUTE_NAMES.Dashboard);
    }
  }, []);
  return (
    <HomePageWrapper>
      <TopNavBarOne />
      <div className="content_container">
        <SideNavBar />
        <div className="page_container d-flex flex-grow-1 fex-column ">
          <Outlet />
        </div>
      </div>
    </HomePageWrapper>
  );
};
